/**
 * TITAN events – single source of truth for TITAN event listing, nav, news, timeline.
 * Used by: nav.jsx (TITAN dropdown), PromotionalHome.js (news, timeline) via siteEvents.
 */

export const TITAN_EVENTS = [
  {
    slug: 'mongolian-critical-zone',
    path: '/titan/mongolian-critical-zone',
    title: 'Mongolian Critical Zone',
    shortDescription: 'Conduct in-situ transdisciplinary research in Ulaanbaatar, Mongolia. Engage with sustainable urban living practices in Ger areas with GerHub. Empower youth in marginalised communities with Nuudelch Zuslan.',
    accentColor: 'orange',
    showInNav: true,
    showInNews: true,
    newsDateLabel: 'Jan 2026',
    newsCategory: 'Research Trip',
    newsBlurb: 'Conduct in-situ transdisciplinary research in Ulaanbaatar, Mongolia. Engage with sustainable urban living practices in Ger areas with GerHub. Empower youth in marginalised communities with Nuudelch Zuslan.',
    order: 1,
    sortDate: '2026-01-18',
    timelineEntries: [
      { date: 'Jan 12-18', label: 'Mongolia Critical Zone' },
    ],
  },
];

/** Events to show in the TITAN section / nav dropdown, sorted reverse chronologically (newest first) */
export const getTitanEventsForListing = () =>
  [...TITAN_EVENTS].sort((a, b) => (b.sortDate || '0000-01-01').localeCompare(a.sortDate || '0000-01-01'));

export const getTitanEventsForNav = () =>
  getTitanEventsForListing().filter((e) => e.showInNav);

export const getTitanEventsForNews = () =>
  getTitanEventsForListing().filter((e) => e.showInNews);

export const getTitanTimelineEntries = () =>
  getTitanEventsForListing().flatMap((event) =>
    (event.timelineEntries || []).map((entry) => ({
      date: entry.date,
      label: entry.label,
      path: event.path,
      accentColor: event.accentColor,
      sortDate: event.sortDate,
    }))
  );
